import React, { Fragment, useContext, useState } from "react";
import { Link } from "gatsby";
import AuthContext from "../../services/firebase/auth-context/provider";
import * as styles from "./magazine.module.css";
import IPBasedLoginContext from "../../services/ip-based-login/provider";
import { toEuroString } from "../../util/format/euro";
import { MagazineBuyState } from "./buy";
import LoadingSpinner from "../common/loading-spinner";
import { LoginPopupContext } from "../../templates/magazine";
var MagazineActions = function MagazineActions(_ref) {
    var price = _ref.price, soldOut = _ref.soldOut, onlyDigital = _ref.onlyDigital, _ref$isLatestMagazine = _ref.isLatestMagazine, isLatestMagazine = _ref$isLatestMagazine === void 0 ? false : _ref$isLatestMagazine, setBuyState = _ref.setBuyState, access = _ref.access;
    var _useContext$ = useContext(AuthContext)[0], authenticated = _useContext$.authenticated, user = _useContext$.user;
    var ipbl = useContext(IPBasedLoginContext);
    var _useState = useState(false), isLoading = _useState[0], setLoading = _useState[1];
    var LoginContext = useContext(LoginPopupContext);
    var message1, message2, action1, action2;
    var notice = createNotice("None", price, onlyDigital); // IP Based logged in
    if (ipbl) {
        message1 = createMessage("read");
        action1 = createDownloadAction(access.downloadUrl);
    } // Not authenticated
    else if (!authenticated) {
        message1 = createMessage("buy");
        action1 = createSubscriptionPlusAction(access.hasActiveSubscription, access.hasPremiumSubscription, isLatestMagazine, user);
        action2 = createBuyMagazineAction(price, soldOut, onlyDigital, false, setBuyState);
        notice = createNotice(soldOut ? "Sold out (no access)" : "Buy", price, onlyDigital);
    } // Checked for access: has access
    else if (access.hasAccess) {
        message1 = createMessage("read");
        action1 = createDownloadAction(access.downloadUrl);
        if (!soldOut && !onlyDigital) {
            message2 = createMessage("buyAgain");
            action2 = createBuyMagazineAction(price, soldOut, onlyDigital, true, setBuyState);
            notice = createNotice("Buy", price, onlyDigital);
        }
        else {
            notice = createNotice("Sold out (has access)", price, onlyDigital);
        }
    } // Checked for access: no access
    else {
        message1 = createMessage("buy");
        action1 = createSubscriptionPlusAction(access.hasActiveSubscription, access.hasPremiumSubscription, isLatestMagazine, user);
        action2 = createBuyMagazineAction(price, soldOut, onlyDigital, false, setBuyState);
        notice = createNotice(soldOut ? "Sold out (no access)" : "Buy", price, onlyDigital);
    }
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoadingSpinner, null);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.actionBox
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            maxWidth: "390px"
        }
    }, message1, action1, message2, action2), notice, !authenticated && !ipbl && /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }, "Schon Abonnent? Dann hier", " ", /*#__PURE__*/ React.createElement("span", {
        className: "font-bold underline hover:no-underline cursor-pointer",
        onClick: LoginContext.onLoginClick
    }, "einloggen"), "!"));
};
var createMessage = function createMessage(type) {
    var message = "Erwerben Sie dieses Themenheft:";
    switch (type) {
        case "buyAgain":
            message = "Erwerben Sie dieses Themenheft erneut:";
            break;
        case "read":
            message = "Lesen Sie dieses Themenheft:";
            break;
    }
    return /*#__PURE__*/ React.createElement("strong", {
        className: "inline-block mt-3"
    }, message);
};
var createSubscriptionPlusAction = function createSubscriptionPlusAction(hasActiveSubscription, hasPremiumSubscription, isLatestMagazine, user) {
    if (!isLatestMagazine)
        return;
    if (hasPremiumSubscription)
        return;
    var mailtoLink = "\n    mailto:aboservice@makroskop.eu?\n    subject=Zu%20Abo%2B%20aufwerten&\n    body=Bitte%20werten%20Sie%20meinen%20Abonnement%20zu%20einem%20Abo%2B%20auf%3A%20" + (user === null || user === void 0 ? void 0 : user.email);
    if (hasActiveSubscription) {
        return /*#__PURE__*/ React.createElement("a", {
            href: mailtoLink,
            className: styles.buttonPurple
        }, /*#__PURE__*/ React.createElement("strong", null, "Zu Abo+ aufwerten"), " und dieses Themenheft erhalten");
    }
    return /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/plus/",
        className: styles.buttonPurple
    }, /*#__PURE__*/ React.createElement("strong", null, "Abo+ zeichnen"), " und dieses Themenheft erhalten");
};
var createBuyMagazineAction = function createBuyMagazineAction(price, soldOut, onlyDigital, buyAgain, setBuyState) {
    var version = soldOut || onlyDigital ? "Digital" : "Print & Digital";
    return /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return setBuyState(buyAgain ? MagazineBuyState.BUY_AGAIN : MagazineBuyState.BUY);
        },
        className: styles.buttonYellow
    }, /*#__PURE__*/ React.createElement("strong", null, version), "-Version f\xFCr ", /*#__PURE__*/ React.createElement("strong", null, toEuroString(price)), " erwerben");
};
var createDownloadAction = function createDownloadAction(downloadUrl) {
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("a", {
        href: downloadUrl,
        target: "_blank",
        className: styles.buttonPurple
    }, "Dieses Themenheft als ", /*#__PURE__*/ React.createElement("strong", null, "PDF"), " herunterladen"));
};
var createNotice = function createNotice(type, price, onlyDigital) {
    if (!onlyDigital) {
        switch (type) {
            case "Buy":
                return /*#__PURE__*/ React.createElement("small", {
                    className: styles.notice
                }, "Sie wollen die Umwelt schonen und das Themenheft f\xFCr ", toEuroString(price), " lediglich digital erwerben?", /*#__PURE__*/ React.createElement("br", null), "Schreiben Sie uns: ", /*#__PURE__*/ React.createElement("a", {
                    href: "mailto:aboservice@makroskop.eu",
                    className: "text-makroBlue hover:underline"
                }, "aboservice@makroskop.eu"), ".");
            case "Sold out (has access)":
                return /*#__PURE__*/ React.createElement("span", {
                    className: "inline-block mt-2"
                }, "Die Print-Version ist derzeit nicht erh\xE4ltlich.");
            case "Sold out (no access)":
                return /*#__PURE__*/ React.createElement("small", {
                    className: styles.notice
                }, "Die Print-Version ist derzeit nicht erh\xE4ltlich.");
        }
    }
    return /*#__PURE__*/ React.createElement(Fragment, null);
};
export default MagazineActions;
